import React from 'react'
import styled, { keyframes } from 'styled-components'

const LoadingContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 100;
  transition: opacity 250ms;
  pointer-events: none;
`

const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`

const Spinner = styled.div`
  width: 20px;
  height: 20px;
  border: 1.5px solid #d6dbf7;
  border-top: 1.5px solid #3249d7;
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`

const LoadingSpinner = ({ visible = true }) => {
  return (
    <LoadingContainer style={{ opacity: visible ? 1 : 0 }}>
      <Spinner />
    </LoadingContainer>
  )
}

export default LoadingSpinner